import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getAllDepartment_By_CompanyID = (id) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.MASTER_DEPARTMENT}/get/All_By_CompanyID/${id}`
    );
};